import React, { lazy } from 'react';
import { Routes, Route } from 'react-router-dom';

const AssignedProjects = lazy(() => import('../../container/facilitator/projects/AssignedProjects'));
const ProjectList = lazy(() => import('../../container/borrower/facilitator-project/projectList'));
const ProjectDetails = lazy(() => import('../../container/borrower/facilitator-project/projectDetail/projectDetails'));
const FacilitatorMilestoneDetails = lazy(
  () => import('../../container/borrower/facilitator-project/facilitatorProjectMilestoneDetails'),
);
const InvestedProjects = lazy(() => import('../../container/facilitator/projects/InvestedProjects'));
const DisburseFunds = lazy(() => import('../../container/borrower/facilitator-project/projectDetail/DisburseFunds'));

function PagesRoute() {
  return (
    <Routes>
      <Route path="list" element={<ProjectList />} />
      <Route path="assigned" element={<AssignedProjects />} />
      <Route path="detail/:id" element={<ProjectDetails />} />
      <Route path="milestones/:id" element={<FacilitatorMilestoneDetails />} />
      <Route path="invested" element={<InvestedProjects />} />
      <Route path="disburse/:id" element={<DisburseFunds />} />
    </Routes>
  );
}

export default PagesRoute;
